import useMutationSupplierCreateUpdate from './supplier-use-mutation-create-update';
import useMutationSupplierImportReimport from "./supplier-use-mutation-import-reimport";
import useMutationSupplierDelete from "./supplier-use-mutation-delete";


export const supplierUseMutation = {
  createUpdate: useMutationSupplierCreateUpdate,
  importReimport: useMutationSupplierImportReimport,
  delete: useMutationSupplierDelete,
};